module.exports = __webpack_public_path__ + "img/01-T.ef3b425e.png";